import { DownloadOutlined, UploadOutlined } from '@ant-design/icons'
import { Button, Form, Upload } from 'antd'
import { useState } from 'react'
import { postImportExcel } from '../../services/postservice'
import ModalCustom from '../common/Modal/ModalCustom'
import openNotification from '../common/Notification/openNotification '
import SelectField from '../common/Select/SelectField'
import { LabelType, ProductType } from './configs'
import styles from './styles.module.scss'
const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: 'red' }}> *</span>}
  </>
)

const FormAddExcel = ({
  isModalOpen,
  setIsModalOpen,
  listRequest,
  listDepartment,
  user,
  getListPost,
  onChangeDepartment,
  LabelType
}) => {
  const [form] = Form.useForm()
  const [excelfileList, setExcelfileList] = useState([])
  const [productImport, setProdudctImport] = useState('')

  const onChangeProductImport = (e) => {
    setProdudctImport(e)
  }

  const handleImport = async () => {
    const values = await form.validateFields()
    const formData = new FormData()
    formData.append('excel', values.files.file)
    formData.append('post_type', values.post_type)
    formData.append('label', values.label)
    formData.append('manager_post_id', values.manager_post_id)
    formData.append('project_id', values.project_id)
    formData.append('department_id', values.department_id)

    try {
      const res = await postImportExcel(formData)
      setIsModalOpen(false)
      getListPost()
      openNotification('success', 'Bạn đã import thành công')
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }
  const handleChangeFileExcel = ({ fileList }) => {
    setExcelfileList(fileList)
  }
  // Render loại hình BĐS theo loại BĐS
  const onChangePostType = (e) => {
    setProdudctImport(e)
  }

  const handlePreview = (file) => {
    // Tạo URL tạm thời để download file
    const url = URL.createObjectURL(file.originFileObj)
    const a = document.createElement('a')
    a.href = url
    a.download = file.name || 'download.xlsx' // Tên file khi tải về
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url) // Giải phóng bộ nhớ
  }

  return (
    <ModalCustom
      title="Import file"
      visible={isModalOpen}
      centered
      width={600}
      // className="modal-bond"
      onCancel={() => {
        setIsModalOpen(false)
        form.resetFields()
        setProdudctImport([])
        setExcelfileList([])
        //   setFileList([])
      }}
      onConfirm={async () => {
        try {
          await form.validateFields() // Kiểm tra validation trước khi tiếp tục
          handleImport() // Nếu hợp lệ thì tiếp tục xử lý
        } catch (error) {
          console.log('Validation failed:', error)
        }
      }}
      confirmText={'Lưu'}
      cancelText="Đóng"
    >
      {/* <Modal
        title={'Import file'}
        visible={createModalImportVisible}
        okText={'Lưu'}
        cancelText={'Huỷ bỏ'}
        width={600}
        onCancel={() => {
          handleModalImportVisible(false);
          formImport.resetFields();
          setProdudctImport('');
        }}
        onOk={formImport.submit} */}

      <Form
        layout="horizontal"
        form={form}
        name="basic"
        labelCol={{ span: 8 }}
        // wrapperCol={{ span: 18 }}
        style={{
          marginTop: 10,
          overflow: 'auto',
          overflowX: 'hidden',
          padding: '0px 10px'
        }}
        labelAlign="left"
        onFinish={(value) => handleImport(value)}
        requiredMark={customizeRequiredMark}
      >
        <SelectField
          label="Nhu cầu (Thuê/Bán)"
          name="label"
          labelRequired="Vui lòng chọn loại nhu cầu"
          required={true}
          options={LabelType}
        />
        <SelectField
          label="Loại bất động sản"
          name="post_type"
          required={true}
          onChange={onChangePostType}
          options={ProductType}
        />
        <SelectField
          label="Tên dự án"
          name="project_id"
          options={listRequest}
        />
        <SelectField
          label="Sàn"
          name="department_id"
          required={true}
          options={listDepartment}
          onChange={onChangeDepartment}
        />
        <SelectField label="Phân quyền" name="manager_post_id" options={user} />
        {/* <SelectField
          label="Quản lý tin"
          name="manager_post_id"
          options={user}
        /> */}

        {/* <Form.Item style={{ width: '100%', marginRight: '20px' }}>
          <Select
            placeholder="Chọn quản lý"
            allowClear
            showSearch
            filterOption={(input, option) =>
              option?.props?.children
                ?.toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            // onChange={onChangeProductImport}
          >
            {user &&
              user.map((el) => (
                <Option value={el.id} key={el.value}>
                  {el.label}
                </Option>
              ))}
          </Select>
        </Form.Item> */}

        <Form.Item label="Upload file" name="files" className={styles.formItem}>
          <Upload
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            fileList={excelfileList}
            onChange={handleChangeFileExcel}
            beforeUpload={() => false}
            onPreview={handlePreview}
            itemRender={(originNode, file) => (
              <a style={{ cursor: 'pointer', textDecoration: 'underline' }}>
                {originNode}
              </a>
            )}
          >
            {excelfileList?.length <= 0 && (
              <Button icon={<UploadOutlined />}>Upload</Button>
            )}
          </Upload>
        </Form.Item>
        {productImport !== '' && (
          <div>
            {productImport === 1 && (
              <Form.Item
                label="Template căn hộ"
                name="files"
                className={styles.formItem}
              >
                <a href="/template/tmp_can_ho.xlsx">
                  <DownloadOutlined /> tmp_can_ho.xlsx
                </a>
              </Form.Item>
            )}

            {productImport === 2 && (
              <Form.Item
                label="Template tòa nhà"
                name="files"
                className={styles.formItem}
              >
                <a href="/template/tmp_toa_nha.xlsx">
                  <DownloadOutlined /> tmp_toa_nha.xlsx
                </a>
              </Form.Item>
            )}
            {productImport === 3 && (
              <Form.Item
                label="Template nhà đát"
                name="files"
                className={styles.formItem}
              >
                <a href="/template/tmp_nha_dat.xlsx">
                  <DownloadOutlined /> tmp_nha_dat.xlsx
                </a>
              </Form.Item>
            )}
            {productImport === 4 && (
              <Form.Item
                label="Template đất nền"
                name="files"
                className={styles.formItem}
              >
                <a href="/template/tmp_dat_nen.xlsx">
                  <DownloadOutlined /> tmp_dat_nen.xlsx
                </a>
              </Form.Item>
            )}
          </div>
        )}

        <span style={{ fontWeight: 600, color: '#f54545', fontSize: 13 }}>
          *Note: Vui lòng chọn loại BĐS để tải template theo đúng loại BĐS
        </span>
      </Form>
    </ModalCustom>
  )
}

export default FormAddExcel
